import { render, staticRenderFns } from "./userVisit.vue?vue&type=template&id=1b80140d"
import script from "./userVisit.vue?vue&type=script&lang=js"
export * from "./userVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports